import React from "react";

const SubmissionList = ({
  submissions = [],
  onApply,
  showFunctionOnly,
  extractFunctionCode,
  targetFunctionName,
}) => {
  if (submissions.length === 0) {
    return (
      <div className="p-6 text-sm text-center text-gray-500 bg-gray-50 rounded-md">
        No submissions yet.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {submissions.map((submission, index) => {
        const submittedCode = submission.code || "";
        const displayCode =
          showFunctionOnly && extractFunctionCode
            ? extractFunctionCode(
                submittedCode,
                submission.language,
                targetFunctionName
              )
            : submittedCode;

        return (
          <div
            key={submission.id || `${submission.submittedAt}-${index}`}
            className="overflow-hidden border border-gray-200 rounded-md bg-gray-50"
          >
            <div className="flex items-center justify-between gap-3 px-4 py-3 bg-white border-b border-gray-200">
              <div className="min-w-0">
                <p className="text-sm font-semibold text-gray-800">
                  Submission {submissions.length - index}
                </p>
                <p className="text-xs text-gray-500">
                  {submission.submittedAt
                    ? new Date(submission.submittedAt).toLocaleString()
                    : "Date unavailable"}
                </p>
              </div>
              <div className="flex items-center flex-shrink-0 gap-3 text-xs">
                <span className="px-2 py-1 font-mono text-gray-700 bg-gray-100 rounded">
                  {submission.language || "Unknown"}
                </span>
                <span className="font-semibold text-green-700">
                  Score: {submission.score ?? 0}
                </span>
              </div>
            </div>
            <pre className="max-h-64 p-4 overflow-auto text-sm leading-relaxed text-gray-900 whitespace-pre-wrap bg-gray-50">
              {displayCode || "// No code submitted"}
            </pre>
            <div className="flex justify-end px-4 py-3 bg-white border-t border-gray-200">
              <button
                type="button"
                onClick={() => onApply(displayCode, submission.language)}
                className="px-3 py-1.5 text-xs font-semibold text-white bg-[#0F537E] rounded-md hover:bg-[#0c4365]"
              >
                Apply
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SubmissionList;
